export type JsonPrimitive = string | number | boolean | null;

export type JsonValue = JsonPrimitive | JsonObject | JsonValue[];

export interface JsonObject {
  [key: string]: JsonValue;
}

/**
 * Normalizes JSON-safe editor/view-model structures before they cross shared
 * API or logging boundaries that require the canonical JsonValue contract.
 */
export const serializeJsonValue = (value: unknown): JsonValue => {
  if (
    value === null ||
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return value;
  }

  if (typeof value === "object") {
    return JSON.parse(JSON.stringify(value)) as JsonValue;
  }

  throw new TypeError("serializeJsonValue expects a JSON-serializable value.");
};
